module.exports = __webpack_public_path__ + "media/bootstrap-icons/bootstrap-icons-81d03567.svg";